const X = ({ size }) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" widt={size} height={size} viewBox={`0 0 24 24`} >
        <path d="M18 6L6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export default X;
